import { Dialog, DialogOverlay, DialogPortal } from "~/ui-kit/dialog";
import { Spinner } from "~/ui-kit/spinner";

interface LoadingOverlayProps {
  loading: boolean;
  message?: string;
  /** Use portal with fixed positioning for global navigation loading (default: absolute for local loading) */
  usePortal?: boolean;
}

export const LoadingOverlay = ({
  loading,
  message = "Loading...",
  usePortal = false,
}: LoadingOverlayProps) => {
  if (!loading) return null;

  // Loading indicator content
  const loadingContent = (
    <div
      role="status"
      aria-live="polite"
      className="bg-card flex flex-col items-center gap-4 rounded-lg p-6 shadow-lg"
    >
      <Spinner className="text-primary h-10 w-10" />
      <span className="text-md font-medium">{message}</span>
    </div>
  );

  // For global navigation: use Dialog + portal with overlay and fixed positioning
  if (usePortal) {
    return (
      <Dialog open>
        <DialogPortal>
          <DialogOverlay className="bg-background/40" />
          <div className="fixed inset-0 z-50 flex items-center justify-center">
            {loadingContent}
          </div>
        </DialogPortal>
      </Dialog>
    );
  }

  // For local loading: use absolute positioning with backdrop
  return (
    <div className="bg-background/20 absolute inset-0 z-50 flex items-center justify-center backdrop-blur-sm">
      {loadingContent}
    </div>
  );
};
